import type { ReactNode } from 'react';
import { SocialIconButton } from './SocialIcon';

/** Header trong panel/modal — SkHeader của bản thiết kế. */
export function SocialHeader({
  title,
  sub,
  onBack,
  left,
  right,
}: {
  title: string;
  sub?: string;
  onBack?: () => void;
  left?: ReactNode;
  right?: ReactNode;
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        padding: '8px',
        minHeight: 60,
        borderBottom: '1px solid var(--border-default)',
        background: 'var(--surface-page)',
        flexShrink: 0,
      }}
    >
      {onBack && <SocialIconButton name="back" label="Quay lại" onClick={onBack} />}
      {left}
      <div style={{ flex: 1, minWidth: 0, paddingLeft: onBack || left ? 0 : 8 }}>
        <div style={{ fontSize: 17, fontWeight: 700, color: 'var(--ink)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{title}</div>
        {sub && <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-secondary)' }}>{sub}</div>}
      </div>
      {right}
    </div>
  );
}
